import { render, staticRenderFns } from "./VacationsView.vue?vue&type=template&id=20f06999&scoped=true"
import script from "./VacationsView.vue?vue&type=script&lang=js"
export * from "./VacationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f06999",
  null
  
)

export default component.exports